import * as angular from 'angular';
import { TransitionService, Transition } from '@uirouter/core';
import { AccountService } from '../../../account/account.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';

export class HeaderController {
    static $inject = ['$transitions', 'accountService', '$translate'];
    headerMenuCollapsed: boolean;
    messageDefault: {
        unverified: 'Your account is currently being reviewed before it is active. You can continue to use the jisp dashboard.',
        warning: 'We attempted to take a payment but it was declined. We will automatically retry taking payment, but please ensure your details are correct and there are no issues with the card issuing bank.',
        suspended: 'Your advertising campaigns have been paused as we were unable to collect payment. Please ensure you have sufficient funds and that your card details are correct with <a ui-sref="app.account.cards">Accounts</a> settings'
    };
    constructor(
        private $transitions: TransitionService,
        private accountService: AccountService,
        private $translate: angular.translate.ITranslateService
    ) {

        /*  $transitions.onStart({}, (transition: Transition) => {
             this.headerMenuCollapsed = true;
         }); */
    }

    toggleHeaderMenu() {
        this.headerMenuCollapsed = !this.headerMenuCollapsed;
    }

    logOff(redirectToHomepage?: boolean) {
        this.accountService.logOut(redirectToHomepage);
    }
}

angular.module('naut')
    .component('topNavbar', {
        template: require('./topNavbar.html'),
        controller: HeaderController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/common/components/topNavbar/topNavbar.component.ts